// extracted by mini-css-extract-plugin
module.exports = {"root":"_1MkYh","SeparateLinesMenuButtonNSkin":"V5fz1","separateLinesMenuButtonNSkin":"V5fz1","linkElement":"_1_18W","gapper":"_1pRYS","borderWrapper":"_4e0KT","label":"HlxB4"};